<template>
    <div class="profile-details" id="profile-details">
        <b-row v-if="isDataLoaded">
            <b-col lg="5">
                <b-row>
                    <b-col sm="4">
                        <client-photo :client="client" v-on="$listeners" />
                    </b-col>
                    <b-col sm="8">
                        <div class="form-group row">
                            <label
                                for="lastname"
                                class="col-sm-4 col-form-label"
                                >First Name:</label
                            >
                            <div class="col">
                                <input
                                    id="firstname"
                                    v-model="client.firstname"
                                    :class="{
                                        'border-danger': errors.has('firstname')
                                    }"
                                    v-validate="'required'"
                                    name="firstname"
                                    class="form-control"
                                    type="text"
                                    placeholder="First Name (required)"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label
                                for="lastname"
                                class="col-sm-4 col-form-label"
                                >Last Name:</label
                            >
                            <div class="col">
                                <input
                                    id="lastname"
                                    v-model="client.lastname"
                                    :class="{
                                        'border-danger': errors.has('lastname')
                                    }"
                                    v-validate="'required'"
                                    name="lastname"
                                    class="form-control"
                                    type="text"
                                    placeholder="Last Name (required)"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="address" class="col-sm-4 col-form-label"
                                >Address:</label
                            >
                            <div v-if="use_google_location" class="col">
                                <v-address-picker
                                    id="address"
                                    v-model="client.address"
                                    module="address"
                                    class="form-control"
                                    placeholder="Address (optional)"
                                    name="address"
                                />
                            </div>
                            <div v-else class="col">
                                <v-address-picker-aws
                                    id="address"
                                    v-model="client.address"
                                    module="address"
                                    placeholder="Address (optional)"
                                    name="address"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="zipcode" class="col-sm-4 col-form-label"
                                >Zipcode:</label
                            >
                            <div v-if="use_google_location" class="col">
                                <v-address-picker
                                    id="zipcode"
                                    v-model="client.zipcode"
                                    module="zipcode"
                                    name="zipcode"
                                    class="form-control"
                                    placeholder="Zipcode (optional)"
                                />
                            </div>
                            <div v-else class="col">
                                <input
                                    id="zipcode"
                                    v-model="client.zipcode"
                                    module="zipcode"
                                    name="zipcode"
                                    placeholder="Zipcode (optional)"
                                    class="form-control"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="city" class="col-sm-4 col-form-label"
                                >City:</label
                            >
                            <div v-if="use_google_location" class="col">
                                <v-address-picker
                                    id="city"
                                    v-model="client.city"
                                    module="city"
                                    class="form-control"
                                    placeholder="City (optional)"
                                />
                            </div>
                            <div v-else class="col">
                                <input
                                    id="city"
                                    v-model="client.city"
                                    module="city"
                                    name="city"
                                    placeholder="City (optional)"
                                    class="form-control"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="county" class="col-sm-4 col-form-label"
                                >County:</label
                            >
                            <div class="col col-form-label">
                                <span>{{ client.county }}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="state" class="col-sm-4 col-form-label"
                                >State:</label
                            >
                            <div v-if="use_google_location" class="col">
                                <v-address-picker
                                    id="state"
                                    v-model="client.state"
                                    module="state"
                                    name="state"
                                    class="form-control"
                                    placeholder="State (optional)"
                                />
                            </div>
                            <div v-else class="col">
                                <input
                                    id="state"
                                    v-model="client.state"
                                    module="state"
                                    name="state"
                                    placeholder="State (optional)"
                                    class="form-control"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="country" class="col-sm-4 col-form-label"
                                >Country:</label
                            >
                            <div v-if="use_google_location" class="col">
                                <v-address-picker
                                    id="country"
                                    v-model="client.country"
                                    module="country"
                                    name="country"
                                    class="form-control"
                                    placeholder="Country (optional)"
                                />
                            </div>
                            <div v-else class="col">
                                <input
                                    id="country"
                                    v-model="client.country"
                                    module="country"
                                    name="country"
                                    placeholder="Country (optional)"
                                    class="form-control"
                                />
                            </div>
                        </div>

                        <div class="form-group row" style="display: none;">
                            <label for="county" class="col-sm-4 col-form-label"
                                >County:</label
                            >
                            <div v-if="use_google_location" class="col">
                                <v-address-picker
                                    id="county"
                                    v-model="client.county"
                                    module="county"
                                    name="county"
                                    class="form-control"
                                    placeholder="County (optional)"
                                />
                            </div>
                            <div v-else class="col">
                                <input
                                    id="county"
                                    v-model="client.county"
                                    module="county"
                                    name="county"
                                    placeholder="County (optional)"
                                    class="form-control"
                                />
                            </div>
                        </div>

                        <div class="form-group row" v-if="datePickerFormatted">
                            <label
                                for="birthdate"
                                class="col-sm-4 col-form-label"
                                >Birthdate:</label
                            >
                            <div class="col">
                                <date-picker
                                    v-show="canEditBirthdate"
                                    :config="datePickerOptions"
                                    :placeholder="
                                        getDateFormat() + ' (optional)'
                                    "
                                    ref="birthdate_client"
                                    v-model="formattedBirthdate"
                                    v-validate="''"
                                    class="form-control"
                                    name="birthdate-client"
                                ></date-picker>
                                <input
                                    v-show="!canEditBirthdate"
                                    id="birthdate-readonly"
                                    name="birthdate-readonly"
                                    class="form-control"
                                    type="text"
                                    :value="formattedBirthdate"
                                    readonly
                                    @click="enableEditBirthdate()"
                                />
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
            <b-col lg="7">
                <b-row>
                    <b-col sm="6">
                        <div class="form-group row">
                            <label for="home" class="col-sm-4 col-form-label"
                                >Home:</label
                            >
                            <div class="col">
                                <div class="row">
                                    <div class="col-3 col-sm-5">
                                        <CountryCode
                                            v-model="client.home_country_code"
                                            :defaultValue="
                                                $root.setting.phone_code
                                            "
                                            class="form-control"
                                        />
                                    </div>
                                    <div class="col pl-0">
                                        <input
                                            id="home"
                                            v-model="client.home"
                                            v-validate="'international_phone'"
                                            :class="{
                                                'border-danger': errors.has(
                                                    'home'
                                                )
                                            }"
                                            name="home"
                                            type="text"
                                            class="form-control"
                                            placeholder="Home Phone (optional)"
                                        />
                                    </div>
                                    <contact-warning
                                        class="col-sm-12"
                                        :type="CLIENT.CONTACT_DETAIL_TYPES.HOME"
                                        :value="client.home"
                                        :contacts="contacts"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="mobile" class="col-sm-4 col-form-label"
                                >Mobile:</label
                            >
                            <div class="col">
                                <div class="row">
                                    <div class="col-3 col-sm-5">
                                        <CountryCode
                                            ref="mobile_country_code"
                                            v-model="client.mobile_country_code"
                                            :defaultValue="
                                                $root.setting.phone_code
                                            "
                                            class="form-control"
                                        />
                                    </div>
                                    <div class="col pl-0">
                                        <input
                                            id="mobile"
                                            v-model="client.mobile"
                                            v-validate="'international_phone'"
                                            :class="{
                                                'border-danger': errors.has(
                                                    'mobile'
                                                )
                                            }"
                                            data-vv-delay="800"
                                            name="mobile"
                                            type="text"
                                            class="form-control"
                                            placeholder="Mobile Phone (optional)"
                                        />
                                    </div>
                                    <contact-warning
                                        class="col-sm-12"
                                        :type="
                                            CLIENT.CONTACT_DETAIL_TYPES.MOBILE
                                        "
                                        :value="client.mobile"
                                        :contacts="contacts"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="work" class="col-sm-4 col-form-label"
                                >Work:</label
                            >
                            <div class="col">
                                <div class="row">
                                    <div class="col-3 col-sm-5">
                                        <CountryCode
                                            v-model="client.work_country_code"
                                            :defaultValue="
                                                $root.setting.phone_code
                                            "
                                            class="form-control"
                                        />
                                    </div>
                                    <div class="col pl-0">
                                        <input
                                            id="work"
                                            v-model="client.work"
                                            v-validate="'international_phone'"
                                            :class="{
                                                'border-danger': errors.has(
                                                    'work'
                                                )
                                            }"
                                            name="work"
                                            type="text"
                                            class="form-control"
                                            placeholder="Work Phone (optional)"
                                        />
                                    </div>
                                    <contact-warning
                                        class="col-sm-12"
                                        :type="CLIENT.CONTACT_DETAIL_TYPES.WORK"
                                        :value="client.work"
                                        :contacts="contacts"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="fax" class="col-sm-4 col-form-label"
                                >Fax:</label
                            >
                            <div class="col">
                                <div class="row">
                                    <div class="col-3 col-sm-5">
                                        <CountryCode
                                            v-model="client.fax_country_code"
                                            :defaultValue="
                                                $root.setting.phone_code
                                            "
                                            class="form-control"
                                        />
                                    </div>
                                    <div class="col pl-0">
                                        <input
                                            id="fax"
                                            v-model="client.fax"
                                            v-validate="'international_phone'"
                                            :class="{
                                                'border-danger': errors.has(
                                                    'fax'
                                                )
                                            }"
                                            name="fax"
                                            type="text"
                                            class="form-control"
                                            placeholder="Fax (optional)"
                                        />
                                    </div>
                                    <contact-warning
                                        class="col-sm-12"
                                        :type="CLIENT.CONTACT_DETAIL_TYPES.FAX"
                                        :value="client.fax"
                                        :contacts="contacts"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="email" class="col-sm-4 col-form-label"
                                >Email:</label
                            >
                            <div class="col">
                                <input
                                    id="email"
                                    v-model="client.email"
                                    :class="{
                                        'border-danger': errors.has('email')
                                    }"
                                    v-validate="'email'"
                                    type="email"
                                    class="form-control"
                                    name="email"
                                    placeholder="Email (optional)"
                                />

                                <contact-warning
                                    :type="CLIENT.CONTACT_DETAIL_TYPES.EMAIL"
                                    :value="client.email"
                                    :contacts="contacts"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label
                                for="reminder"
                                class="col-sm-4 col-form-label"
                                >Reminders:</label
                            >
                            <div class="col">
                                <v-select
                                    id="reminder"
                                    v-model="selectedReminders"
                                    label="text"
                                    placeholder="Reminder Option (optional)"
                                    multiple
                                    :options="filterReminderOptions(rOptions)"
                                    :key="componentKey"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label
                                for="driver_license"
                                class="col-sm-4 col-form-label"
                                >Driver License:</label
                            >
                            <div class="col">
                                <input
                                    id="driver_license"
                                    v-model="client.driver_license"
                                    type="text"
                                    class="form-control"
                                    name="driver_license"
                                    placeholder="Driver License (optional)"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label
                                for="reminder"
                                class="col-sm-4 col-form-label"
                                >Referred By:</label
                            >
                            <div class="col">
                                <vet-select
                                    id="referrer_id"
                                    v-model="client.selectedReferrer"
                                    placeholder="Referral source (optional)"
                                    name="referrer_id"
                                    module="referrer"
                                />
                            </div>
                        </div>
                    </b-col>
                    <b-col sm="6">
                        <div class="form-group row">
                            <label for="balance" class="col-sm-4 col-form-label"
                                >Balance:</label
                            >
                            <div class="col col-form-label">
                                <span>{{
                                    _toCurrency(client.account_balance)
                                }}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label
                                for="payment-terms"
                                class="col-sm-4 col-form-label"
                                >Payment Terms:</label
                            >
                            <div class="col">
                                <select
                                    v-model="client.selectedPaymentTerm"
                                    v-validate="'required'"
                                    name="repeat"
                                    class="form-control"
                                    aria-invalid="false"
                                    :class="{
                                        'border-danger': errors.has('repeat')
                                    }"
                                >
                                    <option
                                        v-for="term in paymentTermsOptions"
                                        :value="term.id"
                                        :key="term.id"
                                    >
                                        {{ term.value }}</option
                                    >
                                </select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label
                                for="exemption"
                                class="col-sm-4 col-form-label"
                                >Exempt From:</label
                            >
                            <div class="col">
                                <v-select
                                    id="exemption"
                                    :options="exemptionFromOptions"
                                    v-model="client.selectedExemptions"
                                    label="value"
                                    placeholder="Select exemption (optional)"
                                    multiple
                                />
                            </div>
                            <br />
                        </div>
                        <div class="form-group row">
                            <label for="status" class="col-sm-4 col-form-label"
                                >Status:</label
                            >
                            <div class="col">
                                <select
                                    id="status"
                                    v-model="client.selectedStatus"
                                    v-validate="'required'"
                                    name="status"
                                    class="form-control"
                                    aria-invalid="false"
                                    :class="{
                                        'border-danger': errors.has('status')
                                    }"
                                >
                                    <option :value="1">Active</option>
                                    <option :value="2">Inactive</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label
                                for="discount"
                                class="col-sm-4 col-form-label"
                                >Discounts:</label
                            >
                            <div class="col">
                                <select
                                    v-model="client.selectedDiscount"
                                    name="discount"
                                    class="form-control"
                                    aria-invalid="false"
                                >
                                    <option
                                        v-for="discount in discountOptions"
                                        :value="discount.id"
                                        class="text-capitalize"
                                        :key="discount.id"
                                    >
                                        {{ discount.label }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div
                            class="form-group row"
                            v-if="client.isRecordSharing"
                        >
                            <label
                                for="discount"
                                class="col-sm-4 col-form-label"
                                >Home Location:</label
                            >
                            <div class="col">
                                <select
                                    v-model="client.homeLocation"
                                    name="homelocation"
                                    class="form-control"
                                    aria-invalid="false"
                                >
                                    <option
                                        v-for="groupBusinessOption in client.listGroupBusiness"
                                        :value="groupBusinessOption.id"
                                        class="text-capitalize"
                                        :key="groupBusinessOption.id"
                                    >
                                        {{ groupBusinessOption.name }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label for="balance" class="col-sm-4 col-form-label"
                                >Last Visit:</label
                            >
                            <div class="col col-form-label">
                                <strong
                                    v-if="client.lastVisit"
                                    class="text-primary cursor-pointer"
                                    @click="goToAppointment(client.lastVisit)"
                                >
                                    {{ _setDateTimeDisplay(client.lastVisit) }}
                                </strong>
                                <span v-else>Not scheduled</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="balance" class="col-sm-4 col-form-label"
                                >Next Visit:</label
                            >
                            <div class="col col-form-label">
                                <strong
                                    v-if="client.nextVisit"
                                    class="text-primary cursor-pointer"
                                    @click="goToAppointment(client.nextVisit)"
                                >
                                    {{ _setDateTimeDisplay(client.nextVisit) }}
                                </strong>
                                <span v-else>Not scheduled</span>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import Vue from "vue";
import _ from "lodash";
import { DateTime } from "luxon";
import vSelect from "vue-select";
import Discount from "@/services/discount";
import Reference from "@/services/reference";
import vetSelect from "@/module/commons/vet-select.vue";
import CountryCode from "@/module/commons/countrycode.vue";
import vAddressPicker from "@/module/commons/vet-address.vue";
import vAddressPickerAws from "@/module/commons/vet-address-aws.vue";
import ClientPhoto from "@/components/client-photos/photo-display";
import ContactWarning from "@/components/commons/client-contact-field-warning";
import ClientContactDetailMixin from "@/mixins/client-contact-details";

import CSETTINGS from "@/constants/settings";
import CLIENT from "@/constants/clients";

const { DISCOUNT_STATUS, DISCOUNT_TYPE } = CSETTINGS;

export default {
    mixins: [ClientContactDetailMixin],
    components: {
        vSelect,
        vetSelect,
        CountryCode,
        ClientPhoto,
        vAddressPicker,
        vAddressPickerAws,
        ContactWarning
    },
    data() {
        return {
            use_google_location: true,
            discountOptions: [],
            datePickerOptions: {
                useCurrent: false,
                maxDate: new Date()
            },
            reminder_options: [],
            paymentTermsOptions: [],
            exemptionFromOptions: [],
            rOptions: [],
            componentKey: 0,
            datePickerFormatted: false,
            canEditBirthdate: true,
            selectedReminders: [],
            contacts: [],
            CLIENT
        };
    },
    computed: {
        currencySymbol() {
            return this.$store.state.setting.currency_symbol;
        },
        setting() {
            return this.$store.state.setting;
        },
        isDataLoaded() {
            return !_.isNull(this.$store.state.client.client_id);
        },
        clientId() {
            return this.$store.state.client.client_id;
        },
        appsURL() {
            return process.env.APPS;
        },
        client: {
            get() {
                return this.$store.getters["client/editDetails"];
            },
            set(value) {
                return this.$store.commit("client/setEditDetails", value);
            }
        },
        formattedBirthdate: {
            get() {
                let format = this._getLuxonFormat();
                let date = this.client.birthdate;

                return this._reformatDateDisplay(date, "yyyy-MM-dd", format);
            },
            set(value) {
                let format = this._getLuxonFormat();
                let date = this._reformatDateDisplay(
                    value,
                    format,
                    "yyyy-MM-dd"
                );

                this.$store.commit("client/setEditDetailsField", {
                    key: "birthdate",
                    value: date
                });
            }
        }
    },
    watch: {
        clientId(newValue, oldValue) {
            if (!_.isNull(newValue) && _.isNull(oldValue)) {
                // this.init();
            }
        },
        "client.firstname"() {
            this.setCanSave();
        },
        "client.lastname"() {
            this.setCanSave();
        },
        "client.home"() {
            this.handleReminders();
        },
        "client.mobile"() {
            this.handleReminders();
        },
        "client.work"() {
            this.handleReminders();
        },
        "client.fax"() {
            this.setCanSave();
        },
        "client.address"() {
            this.handleReminders();
        },
        "client.state"(newValue) {
            if (_.isEmpty(newValue)) {
                this.client.county = "";
            }
        },
        "client.email"() {
            this.handleReminders();
        },
        selectedReminders(value) {
            this.$store.commit("client/setEditDetailsField", {
                key: "selectedReminders",
                value
            });
        }
    },
    mounted() {
        this.errors.clear();
        this.getDiscountOptions();
        this.getContactDetails(this.clientId).then(
            contacts => (this.contacts = contacts)
        );
        this.addressPicked();
        this.use_google_location =
            process.env.USE_GOOGLE_LOCATION === "true" ? true : false;

        if (this.$store.getters["client/editMode"]) {
            this.init();
        }
    },
    methods: {
        add(value, code, text) {
            let indexField = _.findIndex(this.rOptions, function (option) {
                return Number(option.value) == Number(value);
            });
            let notExist = indexField < 0;

            if (notExist) {
                if (this.REMINDER_TYPE.SMS == value) {
                    if (
                        this._isExtensionEnabled("SMS") ||
                        this._isExtensionEnabled("2_WAY_MESSAGING")
                    ) {
                        this.rOptions.push({ value, code, text });
                    }
                } else {
                    this.rOptions.push({ value, code, text });
                    this.selectedReminders.push({ value, code, text });
                }
            } else {
                let isSelected = this.selectedReminders.find(
                    rec => rec.code === code
                );
                if (!isSelected) {
                    this.selectedReminders.push({ value, code, text });
                }
            }
        },
        remove(value) {
            let selected = _.clone(this.selectedReminders) || [];

            this.rOptions = _.filter(this.rOptions, function (opt) {
                return opt.value !== value;
            });

            this.selectedReminders = _.filter(selected, function (opt) {
                return opt.value !== value;
            });
        },
        async init() {
            this.datePickerFormatted = true;

            this.$store.commit("client/setEditDetailsField", {
                key: "selectedStatus",
                value: this.client.status ? this.client.status.id : ""
            });
            this.$store.commit("client/setEditDetailsField", {
                key: "selectedDiscount",
                value: this.client.discount ? this.client.discount.id : ""
            });

            this.setSelectedReferrer(this.client);
            this.getPaymentTermsOptions(this.client);
            this.getExemptionOptions(this.client);
            this.checkBirthdate(this.client);

            this.handleReminders()
                .then(() => {
                    this.setSelectedReminder(this.client);
                })
                .then(() => {
                    this.setCanSave();
                });
        },
        checkBirthdate(client) {
            let check = DateTime.fromString(client.birthdate, this._dateFormat);

            if (check.invalid) {
                this.canEditBirthdate = false;
            }
        },
        enableEditBirthdate() {
            this.canEditBirthdate = true;

            this.$nextTick(function () {
                this.$refs.birthdate_client.$el.focus();
            });
        },
        setSelectedReminder(client) {
            let list = [];
            client.reminderOptions.forEach(reminder => {
                this.rOptions.forEach(option => {
                    if (Number(reminder) == Number(option.value)) {
                        list.push(option);
                    }
                });
            });
            this.selectedReminders = list;
        },
        setSelectedReferrer(client) {
            let referral = client.referral;
            if (referral) {
                let label = "";

                if (referral.type == 0) label = referral.display_name;
                else if (referral.type == 1) label = referral.name;
                else if (referral.type == 2) label = referral.title;

                let selectedReferrer = {
                    id: referral.id,
                    label,
                    type: referral.type
                };

                this.$store.commit("client/setEditDetailsField", {
                    key: "selectedReferrer",
                    value: selectedReferrer
                });
            }
        },
        getPaymentTermsOptions(client) {
            Reference.getPaymentTerms()
                .then(response => {
                    this.paymentTermsOptions = response.resources;

                    return client;
                })
                .then(response => {
                    this.setSelectedPaymentTerm(response);
                })
                .then(() => {
                    this.setCanSave();
                });
        },
        setSelectedPaymentTerm(client) {
            let termId = 1; // 1 is due upon receipt

            this.paymentTermsOptions.forEach(term => {
                if (term.id == client.paymentTermID) {
                    termId = client.paymentTermID;
                }
            });

            this.$store.commit("client/setEditDetailsField", {
                key: "selectedPaymentTerm",
                value: termId
            });
        },
        getExemptionOptions(client) {
            Reference.getExemptionTypes().then(response => {
                this.exemptionFromOptions = response.resources;
                this.$store.commit("client/setEditDetailsField", {
                    key: "selectedExemptions",
                    value: client.exemptOptions
                });
            });
        },
        getDiscountOptions() {
            Discount.getDiscounts()
                .then(response => {
                    if (
                        response.message &&
                        response.message.code === 200 &&
                        response.resource &&
                        response.resource.data
                    ) {
                        this.discountOptions = _.filter(
                            response.resource.data,
                            function (discount) {
                                return (
                                    discount.status === DISCOUNT_STATUS.ACTIVE
                                );
                            }
                        );
                    }
                })
                .then(() => {
                    this.discountOptions.forEach(opt => {
                        let label = opt.name;

                        if (opt.all_category == 1) {
                            if (opt.type === DISCOUNT_TYPE.PERCENTAGE) {
                                label += " (" + opt.amount + "%)";
                            } else {
                                label += " ($" + opt.amount + ")";
                            }
                        }
                        Vue.set(opt, "label", label);
                    });
                })
                .then(() => {
                    this.discountOptions.push({ id: "", label: "No Discount" });
                });
        },
        goToAppointment(date) {
            let formatted = this.$options.filters.isoDateToSeconds(date);
            this.$router.push({
                name: "appointment",
                params: { view: "resourceTimeGridDay", start: formatted }
            });
        },
        async setCanSave() {
            let valid = await this.$validator.validateAll();

            if (!valid) {
                this.$store.commit("client/setEditDetailsField", {
                    key: "canSave",
                    value: false
                });
            } else {
                this.$store.commit("client/setEditDetailsField", {
                    key: "canSave",
                    value: true
                });
            }
        },
        async handleReminders() {
            let client = this.client;
            this.componentKey++;

            this.setCanSave();

            if (
                client.mobile ||
                this.checkContactTypeHasNextPrimary(
                    CLIENT.CONTACT_DETAIL_TYPES.MOBILE,
                    this.contacts
                )
            ) {
                this.add(this.REMINDER_TYPE.SMS, "SMS", "SMS (Text)");
            } else {
                this.remove(this.REMINDER_TYPE.SMS);
            }

            if (
                client.mobile ||
                client.home ||
                client.work ||
                this.checkContactTypeHasNextPrimary(
                    [
                        CLIENT.CONTACT_DETAIL_TYPES.MOBILE,
                        CLIENT.CONTACT_DETAIL_TYPES.HOME,
                        CLIENT.CONTACT_DETAIL_TYPES.WORK
                    ],
                    this.contacts
                )
            ) {
                this.add(this.REMINDER_TYPE.PHONE, "PHONE", "Phone");
            } else {
                this.remove(this.REMINDER_TYPE.PHONE);
            }

            if (
                client.email ||
                this.checkContactTypeHasNextPrimary(
                    CLIENT.CONTACT_DETAIL_TYPES.EMAIL,
                    this.contacts
                )
            ) {
                this.add(this.REMINDER_TYPE.EMAIL, "EMAIL", "Email");
            } else {
                this.remove(this.REMINDER_TYPE.EMAIL);
            }

            if (
                client.address &&
                client.city &&
                client.state &&
                client.zipcode
            ) {
                this.add(this.REMINDER_TYPE.MAIL, "MAIL", "Mail");
            } else {
                this.remove(this.REMINDER_TYPE.MAIL);
            }
        },
        filterReminderOptions(options) {
            let selected = this.selectedReminders || null;
            let filtered = options;

            if (selected) {
                filtered = options.filter(o => selected.indexOf(o) < 0);
            }

            return filtered;
        },
        isDirty() {
            return Object.keys(this.fields).some(key => this.fields[key].dirty);
        },
        addressPicked() {
            let self = this;
            self.$root.$on("addressPicked", address => {
                if (_.isObject(address) && !_.isUndefined(address.address)) {
                    self.client.address = address.address;
                    self.client.zipcode = address.zipcode;
                    self.client.city = address.city;
                    self.client.county = address.county;
                    self.client.state = address.state;
                    self.client.country = address.country;
                }
            });
        }
    }
};
</script>
<style type="text/css" scoped>
.profile-details table tbody tr td:first-child {
    font-weight: bold;
    position: relative;
}

.profile-details .table th,
.profile-details .table td {
    padding: 0px;
    line-height: 35px;
}

.form-control[readonly] {
    background-color: #ffffff;
}
</style>
